import React from 'react';
import PropType from 'prop-types';
import './WelcomeTooltip.css';
import DragToRotateTooltip from '../DragToRotateTooltip/DragToRotateTooltip';
import { isMobileDevice } from 'web-store-modules/packages/obsess-device-detector';
import { Button } from 'web-store-modules/packages/web-store-ui-library';

const browseImg = 'https://cdn.obsess-vr.com/drag-tooltip-desktop.gif';
const productImg = 'https://cdn.obsess-vr.com/mary-kay/hand-icon.png';
const beautyImg = "https://cdn.obsess-vr.com/umg/pokeball-icon.png";
const backImg = 'https://cdn.obsess-vr.com/umg/video-content-hotspot-icon.png';
const isMobile = isMobileDevice();
const desktopTooltip = !isMobile ? {top:'22%'} : {};
const buttonWidth = isMobile ? '240px' : '190px';


const WelcomeTooltip = (props) => {
    const { welcomeMessageStyle, children, showBroseTooltip, showProductTooltip, showBeautyTooltip, isVisible,
        storeId, showMobileTooltip, isMobile, onWelcomeHide } = props;
    const tooltipClass = !isVisible ? 'tooltip-fadeout' : ''

    const onModalHidden = () => {
        onWelcomeHide();
    }

    return (
        <div id="tooltip-container" className={tooltipClass} style={desktopTooltip}>
            <div id="tooltip-component-container" className="flex-center">
                <div className="tooltip-row">
                    <div className="tooltip-col fadeInTooltip">
                        <h3>NAVIGATE</h3>
                        <span className="tooltip-message">
                            Click and drag the screen or use the arrows on the floor to explore.
                        </span>
                        <DragToRotateTooltip imgStyle={{ width: '8.5em', height: '8.5em' }} isTemplate image={browseImg} classes={'tooltip-first-img'} />
                    </div>
                    <div className={'tooltip-col ' + (showProductTooltip ? 'fadeInTooltip' : '')}>
                        {showProductTooltip && <><h3>PRODUCT</h3>
                            <span className="tooltip-message">
                            Click on the icon to see product details and add them to your cart.
                            </span>
                            <DragToRotateTooltip imgStyle={{ width: '4em', height: '4em' }} isTemplate backImg={beautyImg} image={productImg} /> </>}
                    </div>
                    <div className={'tooltip-col ' + (showBeautyTooltip ? 'fadeInTooltip' : '')}>
                        {showBeautyTooltip && <><h3>EXPLORE</h3>
                            <span className="tooltip-message">
                                Click to discover additional content and interact with the space.
                            </span>
                            <DragToRotateTooltip imgStyle={{ width: '3.5em', height: '3em' }} isTemplate image={beautyImg} classes={'star'} /></>}
                    </div>
                   
                    {/* {isMobile && <div style={{ height: "8vh" }} className={'tooltip-col ' + (showMobileTooltip ? 'fadeInTooltip' : '')}>
                        {showMobileTooltip && <>
                            <span className="tooltip-message">
                                {storeTrans[storeId]['portraitViewWarningToolTip']}
                            </span>
                        </>}
                    </div>} */}
                </div>
                <Button
                    hoverStyleChange={false}
                    onClick={onModalHidden}
                    primaryColor='#FAD539'
                    secondaryColor='#FAD539'
                    className="product-button flex-center obsessvr-regularFont full-width pointer"
                    style={{ padding: '0', borderRadius: '0px', width: buttonWidth, height: '2em' }}
                    primaryBorderColor={"#fad639"}
                    secondaryBorderColor={"#fad639"}
                    insetBorder={true}
                    padded={false}
                >
                    <span className='obsessvr-regularFont ' style={{color:'black',fontWeight: '700',fontSize: '14px'}}>
                        Enter Experience
                    </span>
                </Button>
                {children}
            </div>
            <div className="tooltip-row"  style = {{fontFamily: 'Open Sans', fontSize: '12px', bottom: '0px', position: 'absolute'}}>
                    © 2021 Pokémon. © 1995 - 2021 Nintendo/Creatures Inc./GAME FREAK inc. TM, ®, and character names are trademarks of Nintendo
            </div>
        </div>
    );
};

WelcomeTooltip.propTypes = {
    welcomeMessageStyle: PropType.object,
    showBroseTooltip: PropType.bool,
    showBeautyTooltip: PropType.bool,
    showProductTooltip: PropType.bool,
};

export default WelcomeTooltip;
